module.exports = __webpack_public_path__ + "img/share_sdyl.21444e18.png";